import type { JSX } from 'react'

import * as era from '~/core/era'
import { ui } from '~/core/skin'

const skin = era.skin('features/pin-lock/popup/')

PinLockPopup.displayName = 'PinLockPopup'
export function PinLockPopup(): JSX.Element | null {
  return <ui.RenderSkin from={skin} name='pinLockPopup' />
}
